interface IProps {
    list: any[]
}

const AbWaitListPatients = (props: IProps) => {
    return (
        <>
            <div style={{ marginBottom: 10 }}>Click a center alias to go to that center's profile...</div>

            <table>
                <tbody>
                    {props.list.map(item =>
                        <tr key={'ctr-" + item.centerId'}>
                            <td><a href={'/center/' + item.centerId + '/profile/edit'} target='_blank'>{item.centerAlias}</a></td>
                        </tr>
                    )}
                </tbody>
            </table>
        </>
    );
}

export default AbWaitListPatients;